import { Breadcrumb, Button, Col, DatePicker, Form, Input, message, Row, Select } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Mutation, MutationFn } from 'react-apollo';
// import { Link, RouteComponentProps } from 'react-router';
import { Link, RouteComponentProps } from 'react-router-dom';
import { DateRange } from 'src/types/base';

import { Panel } from '../../components/Panel';
import { client } from '../../services/api';
import { Courses } from '../../types/sku';
import { ChangedSku } from './type';

// sku查寻接口
export const skuListQuery = gql`
  query getSkuListQuery($ids: [ID]) {
    skus(ids: $ids) {
      id
      name
      start
      end
      availableFrom
      availableUntil
      price
      soldStock
      totalStock
      completeCourseAt
      totalStock
      courseId
      course {
        id
        name
      }
    }
  }
`;
// 获取所有课程接口
export const getCourses = gql`
  query getCoursesQuery {
    courses {
      id
      serialId
      name
    }
  }
`;
// sku 修改保存接口
export const editSkuMutation = gql`
  mutation editSku(
    $id: Int
    $courseId: Int
    $price: Float
    $startEndRange: DateRange
    $availableDateRange: DateRange
    $completeCourseAt: Date
    $totalStock: Int
    $name: String
  ) {
    editSku(
      id: $id
      courseId: $courseId
      price: $price
      startEndRange: $startEndRange
      availableDateRange: $availableDateRange
      completeCourseAt: $completeCourseAt
      totalStock: $totalStock
      name: $name
    ) {
      id
      courseId
      price
    }
  }
`;

interface State {
  availableDateRange: DateRange;
  price: string;
  totalStock: string;
  startEndRange: DateRange;
  courseId?: number;
  completeCourseAt: Date;
  name: string;
  courseName: string;
  id: number;
  courses: Courses[];
}
interface SkuData {
  skus: ChangedSku[];
}

interface CourseData {
  courses: Courses[];
}

interface Props {
  form: WrappedFormUtils;
}
type AllProps = RouteComponentProps<{ id: string }> & Props;

export class StockEditForm extends Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props);
    this.state = {
      availableDateRange: { from: new Date(), to: new Date() },
      price: '',
      totalStock: '',
      startEndRange: { from: new Date(), to: new Date() },
      courseId: 0,
      completeCourseAt: new Date(),
      name: '',
      courseName: '',
      id: 0,
      courses: [],
    };
  }
  async componentDidMount() {
    const response = await client.query<SkuData>({
      query: skuListQuery,
      variables: { ids: this.props.match.params.id },
    });
    const responseCourse = await client.query<CourseData>({
      query: getCourses,
    });
    const {
      data: { courses },
    } = responseCourse;
    const {
      data: { skus },
    } = response;
    if (skus.length) {
      const [sku] = skus;
      this.setState({
        courses,
        id: sku.id,
        price: sku.price.toString(),
        courseName: sku.course.name,
        name: sku.name,
        availableDateRange: { from: moment(sku.availableFrom).toDate(), to: moment(sku.availableUntil).toDate() },
        startEndRange: { from: moment(sku.start).toDate(), to: moment(sku.end).toDate() },
        completeCourseAt: moment(sku.completeCourseAt).toDate(),
        totalStock: sku.totalStock,
        courseId: sku.courseId,
      });
    }
  }

  onCourseChange = (e: number) => {
    const { courses } = this.state;
    let courseNameMiddle = '';
    for (let i = 0, len = courses.length; i < len; i += 1) {
      if (Number(courses[i].id) === Number(e)) {
        courseNameMiddle = courses[i].name;
      }
    }
    this.setState({
      courseId: e,
      courseName: courseNameMiddle,
    });
  };

  onPriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      price: e.target.value,
    });
  };

  onTotalStockInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      totalStock: e.target.value,
    });
  };

  onSkuNameInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      name: e.target.value,
    });
  };

  async onUpdateButtonClick(
    editSkuMutation: MutationFn<
      any,
      {
        id: number;
        courseId: number | undefined;
        price: string;
        startEndRange: DateRange;
        availableDateRange: DateRange;
        completeCourseAt: Date;
        totalStock: string;
        name: string;
      }
    >,
  ) {
    this.props.form.validateFields(async (err, values) => {
      if (err) {
        message.error(err);
        return;
      }
      const { name, price, startEndRange, availableDateRange, completeCourseAt, totalStock, courseId } = values;
      const newAvailableDateRange =
        availableDateRange && availableDateRange.length > 1
          ? {
              from: moment(availableDateRange[0]).startOf('day').toDate(),
              to: moment(availableDateRange[1]).endOf('day').toDate(),
            }
          : { from: new Date(), to: new Date() };

      const newStartEndRange =
        startEndRange && startEndRange.length > 1
          ? {
              from: moment(startEndRange[0]).startOf('day').toDate(),
              to: moment(startEndRange[1]).endOf('day').toDate(),
            }
          : { from: new Date(), to: new Date() };
      const newCompleteCourseAt = completeCourseAt ? moment(completeCourseAt).startOf('day').toDate() : new Date();
      if (
        moment(newAvailableDateRange.from).valueOf() > moment(newAvailableDateRange.to).valueOf() ||
        moment(newStartEndRange.from).valueOf() > moment(newStartEndRange.to).valueOf() ||
        moment(newAvailableDateRange.from).valueOf() > moment(newCompleteCourseAt).valueOf() ||
        moment(newCompleteCourseAt).valueOf() > moment(newStartEndRange.to).valueOf()
      ) {
        message.error('时间设置有错误');
        return;
      }
      if (!courseId) {
        message.error('请选择课程');
        return;
      }
      if (Number(price) < 0) {
        message.error('请设置课程价格');
        return;
      }
      if (Number(totalStock) < 0) {
        message.error('请填写符合逻辑的总库存');
        return;
      }
      if (!name) {
        message.error('请填写sku名称');
        return;
      }
      this.setState(
        {
          courseId,
          price,
          totalStock,
          name,
          startEndRange: newStartEndRange,
          availableDateRange: newAvailableDateRange,
          completeCourseAt: newCompleteCourseAt,
        },
        async () => {
          try {
            await editSkuMutation();
            message.success(' 更新成功');
          } catch {
            message.error('更新失败');
          }
        },
      );
    });
  }

  render() {
    const {
      courses,
      name,
      price,
      startEndRange,
      availableDateRange,
      completeCourseAt,
      totalStock,
      id,
      courseId,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/Stock/list`}>库存管理</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>修改</Breadcrumb.Item>
        </Breadcrumb>
        <Panel style={{ padding: 24, height: 1000 }}>
          <Form>
            <Row style={{ marginTop: 8 }}>
              <Col span={6}>
                <Form.Item label={`课程名称:`}>
                  {getFieldDecorator('courseId', { initialValue: courseId && courseId.toString() })(
                    <Select
                      placeholder={'请选择课程'}
                      // value={courseId}
                      style={{ width: 188 }}
                      // onChange={this.onCourseChange}
                    >
                      {courses.map(option => {
                        return <Select.Option key={option.id}>{option.name}</Select.Option>;
                      })}
                    </Select>,
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ marginTop: 8 }}>
              <Col span={6}>
                <Form.Item label={`Sku名称:`}>{getFieldDecorator('name', { initialValue: name })(<Input />)}</Form.Item>
              </Col>
            </Row>
            <Row style={{ marginTop: 8 }}>
              <Col span={6}>
                <Form.Item label={`单价:`}>
                  {getFieldDecorator('price', { initialValue: price })(<Input type="number" />)}
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ marginTop: 8 }}>
              <Col span={7}>
                <Form.Item label={`课程有效期:`}>
                  {getFieldDecorator('startEndRange', {
                    initialValue: [moment(startEndRange.from), moment(startEndRange.to)],
                  })(<DatePicker.RangePicker />)}
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ marginTop: 8 }}>
              <Col span={7}>
                <Form.Item label={`售卖时间:`}>
                  {getFieldDecorator('availableDateRange', {
                    initialValue: [moment(availableDateRange.from), moment(availableDateRange.to)],
                  })(<DatePicker.RangePicker />)}
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ marginTop: 8 }}>
              <Col span={6}>
                {moment(completeCourseAt).isValid() ? (
                  <Form.Item label={`结课时间:`}>
                    {getFieldDecorator('completeCourseAt', { initialValue: moment(completeCourseAt) })(<DatePicker />)}
                  </Form.Item>
                ) : (
                  <Form.Item label={`结课时间:`}>{getFieldDecorator('completeCourseAt')(<DatePicker />)}</Form.Item>
                )}
              </Col>
            </Row>
            <Row style={{ marginTop: 8 }}>
              <Col span={6}>
                <Form.Item label={`总库存:`}>
                  {getFieldDecorator('totalStock', { initialValue: totalStock })(<Input type="number" />)}
                </Form.Item>
              </Col>
            </Row>
            <Button
              style={{ marginRight: 5 }}
              onClick={() => {
                this.props.history.goBack();
              }}
            >
              返回
            </Button>
            <Mutation
              mutation={editSkuMutation}
              variables={{
                id,
                courseId,
                price,
                startEndRange,
                availableDateRange,
                completeCourseAt,
                totalStock,
                name,
              }}
            >
              {editSkuMutation => {
                return (
                  <Button
                    style={{ marginTop: 30 }}
                    onClick={async () => {
                      await this.onUpdateButtonClick(editSkuMutation);
                    }}
                  >
                    更新
                  </Button>
                );
              }}
            </Mutation>
          </Form>
        </Panel>
      </>
    );
  }
}

export const StockEdit = Form.create({ name: 'StockEdit' })(StockEditForm);



// WEBPACK FOOTER //
// ./src/screens/stock/StockEdit.tsx